import { render, staticRenderFns } from "./buyer.vue?vue&type=template&id=47b5ac14&scoped=true&"
import script from "./buyer.vue?vue&type=script&lang=js&"
export * from "./buyer.vue?vue&type=script&lang=js&"
import style0 from "./buyer.vue?vue&type=style&index=0&id=47b5ac14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b5ac14",
  null
  
)

export default component.exports